<ion-menu contentId="root-component"
          type="overlay"
          menuId="left-menu">
    <ion-content>
        <ion-list class="ion-no-padding">
            <!-- Menu -->
            <ion-menu-toggle>
                <ion-item class="ion-no-padding"
                          color="primary"
                          [button]="true"
                          [detail]="false">
                    <ion-icon slot="end" name="menu" color="light"></ion-icon>
                </ion-item>
            </ion-menu-toggle>

            <!-- Home -->
            <ion-menu-toggle [routerLink]="['/']">
                <ion-item lines="full"
                          [button]="true"
                          [detail]="true">
                    <ion-icon slot="start" name="home-outline"></ion-icon>
                    <ion-text>Home</ion-text>
                </ion-item>
            </ion-menu-toggle>

            <!-- Login -->
            <ion-menu-toggle [routerLink]="['/login']" routerDirection="forward">
                <ion-item lines="full"
                          [button]="true"
                          [detail]="true">
                    <ion-icon slot="start" name="log-in-outline"></ion-icon>
                    <ion-text>Login</ion-text>
                </ion-item>
            </ion-menu-toggle>

            <!-- Analysis -->
            <ion-menu-toggle [routerLink]="['/analysis']" routerDirection="forward">
                <ion-item lines="full"
                          [button]="true"
                          [detail]="true">
                    <ion-icon slot="start" name="calculator-outline"></ion-icon>
                    <ion-text>Analysis</ion-text>
                </ion-item>
            </ion-menu-toggle>

            <!-- Marketing -->
            <ion-menu-toggle [routerLink]="['/marketing']">
                <ion-item lines="full"
                          [button]="true"
                          [detail]="true">
                    <ion-icon slot="start" name="cash-outline"></ion-icon>
                    <ion-text>Marketing</ion-text>
                </ion-item>
            </ion-menu-toggle>

            <!-- Contract -->
            <ion-menu-toggle [routerLink]="['/contract']">
                <ion-item lines="full"
                          [button]="true"
                          [detail]="true">
                    <ion-icon slot="start" name="documents-outline"></ion-icon>
                    <ion-text>Contract</ion-text>
                </ion-item>
            </ion-menu-toggle>

            <!-- Enterprise -->
            <ion-menu-toggle [routerLink]="['/enterprise']">
                <ion-item lines="full"
                          [button]="true"
                          [detail]="true">
                    <ion-icon slot="start" name="briefcase-outline"></ion-icon>
                    <ion-text>Enterprise</ion-text>
                </ion-item>
            </ion-menu-toggle>

            <!-- Contact -->
            <ion-item lines="full"
                      href="mailto:admin@vesta.app"
                      [button]="true"
                      [detail]="true">
                <ion-icon slot="start" name="mail-outline"></ion-icon>
                <ion-text>Contact</ion-text>
            </ion-item>

            <!-- Enterprise -->
            <ion-menu-toggle [routerLink]="['/home']">
                <ion-item lines="full"
                          [button]="true"
                          [detail]="true">
                    <ion-icon slot="start" name="briefcase-outline"></ion-icon>
                    <ion-text>Test</ion-text>
                </ion-item>
            </ion-menu-toggle>
        </ion-list>
    </ion-content>
</ion-menu>
